//简体 中文
module.exports = {
  // 公共语言档
  Common: {
    quitTips1: '亲爱的小朋友，你的学习时间已经很长，<br>将会自动退出',
    quitTips2: '亲爱的小朋友，你已经学习很久了，<br>建议你退出本应用，去休息一会儿吧',
    confirm:'确定',
    cancle:'取消',
    fininsh:'完成',
    man:'男',
    woman:'女',
    quit:'退出',
    quitEvalute:'退出挑战',
    tips:'提示',
    confirmQuit:'确定退出',
    think:'我再想想',
    quitLogin:'退出登录',
    quitAccount:'是否退出当前账户？',
    invalid:'是否退出挑战？本次挑战将作废',
    timeOut:'挑战超时，本次练习作废',
    PleaseAnswer:'请作答',
    confirmDelete:'确定删除',
    loadCountine:'加载更多...',
    title:'奇趣Online',
    kctvOne:'互动讲堂',
    kctvTwo:'聚焦课堂',
    subject: '题'
  },
  //头部
  Header:{
    review:'复习',
    evaluation:'测评',
    FunClass:'趣课堂',
    vedio:'视频',
    book:'图书',
    task:'作业任务',
    myTask:'我的任务',
    studyCenter:'学习中心',
    myCenter:'个人中心',
    noData:'暂时没有课时任务',
    noData1:'暂无作业任务数据',
    quitAccount:'是否退出当前账户？',
    isQuit:'是否退出练习？本次练习将作废',
  },
  //登录
  Login:{
    account:'账号密码登录',
    phone:'手机快速登录',
    phTips1:'账号/手机号',
    phTips2:'请输入密码',
    rember:'记住密码',
    forget:'忘记密码？',
    phonePH:'请输入手机号',
    verifyPH:'请输入验证码',
    login:'登录',
    getPsw:'获取验证码',
    phoneNull:'手机号不能为空',
    phoneTips:'请输入正确的手机号',
    again:'重新获取',
    placeYourPhone:'请输入手机号'
  },
  //忘记密码
  Forget:{
    reset:'重置密码',
    verifyIdentidy:'验证身份',
    setNew:'设置新密码',
    setSuccess:'设置成功',
    phonePH:'请输入手机号',
    verifyPH:'请输入验证码',
    newpswpH:'请输入新密码',
    againpsw:'请再次输入新密码',
    resetSuccess:'密码修改成功！',
    getVerify:'获取验证码',
    phoneNull:'手机号不能为空',
    phoneTips:'请输入正确的手机号',
    againGet:'重新获取',
    noNull:'密码不可为空',
    changepsw:'修改密码请输入6位以上的字母或数字',
    changepsw1:'两次密码不相等'
  },
  //首页
  Home:{
    noName:'未知名',
    noSchool:'展示没有学校',
    noClass:'暂时没有班级',
    noData1:'暂无作业任务数据',
    noData:'暂时没有课时任务',
  },
  //个人中心
  MyCenter:{
    currentBaby:'当前宝宝',
    currentBabyInfo:'当前宝宝信息',
    schoolName:"学校名称：",
    className:'班级名称：',
    brand:'班级编号：',
    code:'班别：',
    birthday:'出生日期：',
    pswChange:'密码切换',
    verifty:'验证码切换',
    band:'您当前绑定的手机号',
    pswHD:'请输入密码',
    veriftyHD:'请输入验证码',
    changeBaby:'切换宝宝',
    getCode:'获取验证码',
    againget:'重新获取',
    goldSource:'金币来源',
    deSource:'钻石来源',
    singe:'个',
    source:'来源',
    studyCount:'学习统计',
    studyHour:'学习课时：',
    hour:'次数',
    fininshTask:'活动记录：',
    reviewTask:'完成活动闯关关卡：',
    myEvalute:'自我练习测评：',
    read:'阅读书籍：',
    times:'次',
    book:'本',
    visit:'观看动画视频：',
    listenMp3:'听',
    monthGet:'本月获得',
    getWeek:'按周选择',
    getMonth:'按月选择',
    to:'至',
    setting:'设置',
    setMusic:'背景音乐',
    reword:'奖励来源',
    trace:'学习轨迹',
    recordTipText1: '暂无金币来源哦',
    recordTipText2: '暂无钻石来源哦',
    pswTips:'密码请填入6位以上的字母和数字'
  },
  //测评中心
  Evaluation:{
    myReport: '我的报告',
    explain: '说明',
    unit:'单元练习',
    wrong:'错题练习',
    record:'测评记录',
    groupUnit:'组合练习',
    itemTest:'分项测验',
    start:'开始练习',
    dearFriend:'亲爱的小朋友',
    all:'请再挑战',
    allSchoolTip: '请再挑战',
    question:'题',
    complete:'交卷',
    prev:'上一题',
    next:'下一题',
    AnsweringArea:'作答区域',
    questionArea:'题目区域',
    answerResult:'挑战结果',
    analysis:"解析",
    good:'非常棒!',
    ComeOn:'再接再厉，继续加油哦～',
    wrongQuestion:'再次挑战',
    againTest:'再次挑战',
    getMonery:'恭喜获得奖励',
    goBack:'返回测评首页',
    removeQuestion:'移除错题',
    questionTitle:'关卡分析',
    remove:'移除错题',
    content1:'亲爱的小朋友，恭喜你这道题答对了！',
    content2:'如果这道题你已经掌握了，点击移除按钮可以把这道题移除错题库，',
    content3:'以后不用练习这道题喔',
    RemoveConfirm:'移除',
    ability:'能力指标分析',
    ablityAnaly:'能力分析',
    testAnaly:'报告',
    dearChild:'亲爱的小朋友，暂时还没有测评记录哦',
    submitQuestion: '提交'
  },
  //任务中心
  TaskCenter:{
    historyTask:'历史任务',
    studyTask:'学习目标',
    goback:'返回简介',
    RecordingTask:'录音任务',
    noFinessed:'未完成',
    Finessed:'已完成',
    goFinessed:'去完成',
    task1:'i探险',
    task2:'检测任务',
    task3:'i互动',
    task4:'阅读任务',
    task5:'亲子任务',
    task6:'录音任务',
    choose:'请选择',
    load1:'请下载"奇趣Online"App进行游戏',
    load2:'请到家长端完成',
    load3:'请到"奇趣Online"App 完成录音',
  },
  //复习,MP3,视频,图书
  blendType:{
    bookName:'请输入您想看的书名',
    noBook:'亲爱的小朋友，暂时还没有的图书哦',
    read:'立即阅读',
    cancleLove:'取消喜欢',
    love:'喜欢',
    suitage:'选择适合的年龄',
    suitBook:'选择图书的类型',
    allBook:'全部书籍',
    noVedio:'亲爱的小朋友，暂时还没有的视频哦',
    reword:'恭喜获得奖励',
    review:'KC TV',
    book:'KC Talk',
    forword:'敬请期待！',
    noAudio:'亲爱的小朋友，暂时还没有的音频哦',
    isQuit:'是否退出复习？',
    load:'请下载 "奇趣online" APP进行游戏。',
    noLove:'亲爱的小朋友，你还没有收藏喜欢的视频哦',
    nowPlay:'立即播放',
    Replay:'重新播放',
    alread:'已读',
    myloveBook:'我喜欢的书籍',
    zhong:'中',
    ying:'英',
    allVedio:'全部视频',
    myLoveVedio:'我喜欢的视频',
    veryLove:'我很喜欢',
    noPCTxt: '暂无评测数据'
  }
}